var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NjBtn,{class:{ 'mb-5': _setup.isHidden },attrs:{"outlined":"","block":_vm.$vuetify.breakpoint.xs,"color":"primary"},on:{"click":function($event){_setup.isHidden = !_setup.isHidden}}},[_vm._v(" "+_vm._s(_setup.isHidden ? "Show" : "Hide")+" "),_vm._t("default",function(){return [_vm._v("Search Filters")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }